import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
// import searchicon from "../../assets/search.svg";
// import sliderrightarrow from "../../assets/sliderrightarrow2.svg";
// import sliderleftarrow from "../../assets/sliderleftarrow2.svg";
import { API } from "../../axios";


function RightArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "transparent" }}
      onClick={onClick}
    >
      {/* <img
        src={sliderrightarrow}
        alt="Prev"
        style={{ width: "30px", height: "30px" }}
      /> */}
    </div>
  );
}

function LeftArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "transparent" }}
      onClick={onClick}
    >
      {/* <img
        src={sliderleftarrow}
        alt="Prev"
        style={{ width: "30px", height: "30px" }}
      /> */}
    </div>
  );
}

const ProjectPanelPost = () => {
  const [projectPosts, setProjectPosts] = useState([]);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    // Fetch blog posts from the API
    // const fetchProjectPosts = async () => {
    //   try {
    //     const res = await API.get("https://cipl.aimantra.info/website/testimonialsList/");
    //     const projectdata = res.data;
    //     setProjectPosts(projectdata); // Assuming the response data is an array of blog posts
    //   } catch (error) {
    //     console.error("Error Occured! Please try again after a while.", error);
    //   }
    //   setloading(false);
    // };

    // fetchProjectPosts();
  }, [projectPosts]);
  // Delete function
  const handleDelete = async (id) => {
    try {
      await API.delete(`https://cipl.aimantra.info/website/projectsList/<str:pk>/${id}`);
      setProjectPosts(projectPosts.filter((post) => post.id !== id));
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      await API.put(`https://cipl.aimantra.info/website/projectsList/<str:pk>/${id}`, updatedData);
      setProjectPosts(projectPosts.map((post) => (post.id === id ? { ...post, ...updatedData } : post)));
    } catch (error) {
      console.error("Error editing post:", error);
    }
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <RightArrow />,
    prevArrow: <LeftArrow />,
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="flex flex-wrap justify-between">
        <h2 className="text-4xl font-bold mb-8 text-star">
          Recent <span className="mainred">Project Post</span>
        </h2>
        <div className="w-[30%] p-2 px-6 h-12 flex gap-2 items-center cursor-pointer bg-white rounded-lg border-2">
          {/* <img src={searchicon} alt="Search Blogs" /> */}
          <input type="text" placeholder="Search" className="outline-none" />
        </div>
      </div>
      <Slider {...settings} className="relative">
        {projectPosts.map((post) => (
          <div key={post.id} className="p-4" loading={loading}>
            <div className="bg-[#F0F5FA]  cursor-pointer p-6 rounded-lg shadow-lg hover:shadow-xl  border-[1px] hover:bg-white transition-shadow duration-300 relative  h-[300px] overflow-hidden">
              {/* Edit and Delete buttons positioned at the top-right */}
              <div className="absolute top-4 right-4 flex space-x-3">
                <button
                  onClick={() => handleEdit(post.id)}
                  className="bg-[#FFF3F3] text-red-500 p-2 rounded-full hover:bg-red-200 transition duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                      fill="#90051E"
                    />
                  </svg>
                </button>
                <button
                  onClick={() => handleDelete(post.id)}
                  className="bg-[#FFF3F3] text-red-500 p-2 rounded-full hover:bg-red-200 transition duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                      fill="#90051E"
                    />
                  </svg>
                </button>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 w-4/5 mb-3 leading-tight ">
                {post.company_Name}
              </h3>

              <p className="text-gray-600 leading- mb-4">{post.reviews}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProjectPanelPost;
